import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Radio, Switch, Checkbox, Form, Typography, Select } from 'antd'
import { formItemLayoutEqual } from './Styles'
import _ from 'lodash'
import { withApollo } from '@apollo/client/react/hoc'
import { withRouter } from 'react-router-dom'

const { Text } = Typography

const NO_SUBTEAM_POLICY = -1

class BooleanValueWithInheritancePolicy extends Component {
	constructor(props) {
		super(props)
		this.state = this.getStateFromProps(this.props)
	}

	// Update the state when we switch from a team to another through the list
	componentDidUpdate(prevProps) {
		if (!_.isEqual(prevProps.value, this.props.value)) {
			this.setState(this.getStateFromProps(this.props))
		}
	}

	getStateFromProps(props) {
		return {
			...props.value,
			loading: false,
			subPolicyValue:
				props.value.applyToChildren ?
					props.value.valueForChildren
				:	NO_SUBTEAM_POLICY
		}
	}

	setSubPolicyValue(value) {
		this.setState({ subPolicyValue: value }, this.onChange)
	}

	setValue(value) {
		this.setState({ value }, this.onChange)
	}

	// this method generate a BooleanValueWithInheritancePolicy value from the component state
	// and forward it to the parent component
	async onChange() {
		this.setState({ loading: true })
		await this.props.onChange({
			value: this.state.value,
			// the sub policy is displayed in the UI by a dropdown that we need
			// to convert to a combinaison of boolean for the BooleanValueWithInheritancePolicy model
			// the NO_SUBTEAM_POLICY value means no subteam policy
			applyToChildren:
				this.state.subPolicyValue === NO_SUBTEAM_POLICY ? false : true,
			valueForChildren:
				this.state.subPolicyValue !== NO_SUBTEAM_POLICY ?
					this.state.subPolicyValue
				:	undefined
		})
		this.setState({ loading: false })
	}

	render() {
		const { intl } = this.props

		const mainSwitch = (
			<Form.Item
				label={this.props.label}
				{...(this.props.extraProps ?? {})}
			>
				<Switch
					data-test={`${this.props['data-test']}-main-switch`}
					loading={this.state.loading}
					checked={this.state.value}
					onChange={(v) => this.setValue(v)}
					checkedChildren={intl.formatMessage({ id: 'yes' })}
					unCheckedChildren={intl.formatMessage({ id: 'no' })}
				/>
			</Form.Item>
		)

		const managedByParentSwitch = (
			<Form.Item
				label={this.props.label}
				{...(this.props.extraProps ?? {})}
			>
				<Switch
					data-test={`${this.props['data-test']}-parent-value-switch`}
					disabled={true}
					checked={this.props.parentValue}
					checkedChildren={intl.formatMessage({ id: 'yes' })}
					unCheckedChildren={intl.formatMessage({ id: 'no' })}
				/>

				<Text
					data-test={`${this.props['data-test']}-managed-by-parent-text`}
					type="secondary"
					style={{ marginLeft: 10 }}
				>
					<FormattedMessage id="teams.details.settings.managedByParent" />
				</Text>
			</Form.Item>
		)

		const subTeamPolicy = (
			<>
				<Form.Item
					{...formItemLayoutEqual}
					label={intl.formatMessage({
						id: 'teams.details.settings.subTeamsPolicy.label'
					})}
					style={{ marginTop: -20 }}
				>
					<Select
						data-test={`${this.props['data-test']}-sub-policy-select`}
						style={{ width: 200 }}
						value={this.state.subPolicyValue}
						onChange={(v) => this.setSubPolicyValue(v)}
					>
						<Select.Option value={NO_SUBTEAM_POLICY}>
							{
								<FormattedMessage
									id={`teams.details.settings.subTeamsPolicy.options.${this.props?.subPolicyOptions?.[0] ?? 'noRestriction'}`}
								/>
							}
						</Select.Option>
						<Select.Option value={true}>
							{
								<FormattedMessage
									id={`teams.details.settings.subTeamsPolicy.options.${this.props?.subPolicyOptions?.[1] ?? 'allow'}`}
								/>
							}
						</Select.Option>
						<Select.Option value={false}>
							{
								<FormattedMessage
									id={`teams.details.settings.subTeamsPolicy.options.${this.props?.subPolicyOptions?.[2] ?? 'forbid'}`}
								/>
							}
						</Select.Option>
					</Select>
				</Form.Item>
			</>
		)

		return (
			<>
				{this.props.managedByParent ?
					managedByParentSwitch
				:	mainSwitch}
				{!this.props.managedByParent ? subTeamPolicy : <></>}
			</>
		)
	}
}

export default withRouter(
	withApollo(injectIntl(BooleanValueWithInheritancePolicy))
)
